import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Skeleton,
    Tooltip,
    Typography,
    useMediaQuery,
} from '@mui/material';
import InputForm from '../../../commun/input-form';
import React, { ChangeEvent } from 'react';
import MeterReading from '../../../commun/meter-reading';
import imgMeterReading from '../../../../assets/images/releveCompteur.png';
import theme from '../../../../theme';
import InfoIcon from '@mui/icons-material/Info';
import { Form, Formik } from 'formik';
import { number, object, string } from 'yup';
import { Link } from 'react-router-dom';
import './moving-in-step-two.form.scss';

/**
 * Formulaire j'emménage étape deux
 * @param props
 * @constructor
 */
export default function MovingInStepTwoForm(props: {
    handlerChangeIsOwner: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    isOwner?: string;
    newAddress?: string;
    handleSumbitForm: (values: any) => void;
    validForm: boolean;
    isOwnerError: boolean;
}) {
    //Détection mobile
    const matches = useMediaQuery('(min-width:600px)');
    // Message affiché dès que l'utilisateur oublira un champ du formulaire
    const message = 'Champ obligatoire';
    const helperTextIsOwner = 'Veuillez renseigner ce champ.';
    //define number
    const eight = 8;
    const twelve = 12;

    // Schéma de validation des données
    const validationSchema = object({
        //Validation de la date de sortie
        movingInDate: string().trim().required("Veuillez renseigner la date d'emménagement"),
        numberOne: number().required(message),
        numberTwo: number().required(message),
        numberThree: number().required(message),
        numberFour: number().required(message),
        numberFive: number().required(message),
    });

    // Valeurs par défaut
    const iniValues = {
        movingInDate: '',
        numberOne: '',
        numberTwo: '',
        numberThree: '',
        numberFour: '',
        numberFive: '',
    };

    return (
        //Début de la page
        //Formulaire avec tableau pour afficher correctement les champs
        <Formik initialValues={iniValues} onSubmit={props.handleSumbitForm} validationSchema={validationSchema}>
            <Form>
                {/*Titre*/}
                <Typography variant="h4">J'emménage</Typography>
                {/*Grid*/}
                <Grid container spacing={2} className="moving-in-step-two-form" sx={{ alignItems: 'stretch' }}>
                    {/*premier bloc*/}
                    <Grid item xs={12} sm={4}>
                        {/*Votre demande*/}
                        <Paper sx={{ height: '100%' }}>
                            <Box sx={{ padding: '20px' }}>
                                <Typography variant="h5">Votre demande</Typography>
                                <Grid container>
                                    {/*Champ date d'emmenagement*/}
                                    <Grid item xs={12}>
                                        <InputForm
                                            type="date"
                                            id="movingInDate"
                                            name="movingInDate"
                                            label="Date de signature du bail d’entrée ou de l’acte notarial"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/*Question facture*/}
                                        <Typography variant="body1">Vous allez être (*) :</Typography>
                                        <FormControl error={props.isOwnerError}>
                                            <RadioGroup
                                                aria-labelledby="isOwner"
                                                name="isOwner"
                                                value={props.isOwner}
                                                onChange={props.handlerChangeIsOwner}
                                            >
                                                <FormControlLabel
                                                    value={'owner'}
                                                    control={<Radio />}
                                                    label="Propriétaire"
                                                />
                                                <FormControlLabel
                                                    value={'tenant'}
                                                    control={<Radio />}
                                                    label="Locataire"
                                                />
                                            </RadioGroup>
                                            <FormHelperText>
                                                {props.isOwnerError ? helperTextIsOwner : ''}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </Grid>
                    {/*Deuxieme bloc*/}
                    <Grid item xs={12} sm={8}>
                        {/*nouvelle habitation*/}
                        <Paper sx={{ height: '100%' }}>
                            <Box sx={{ padding: '20px' }}>
                                <Typography variant="h5">Nouvelle habitation</Typography>
                                {/*adresse*/}
                                {props.newAddress ? (
                                    <Typography variant="body1" sx={{ marginBottom: '10px' }}>
                                        {props.newAddress}
                                    </Typography>
                                ) : (
                                    <Skeleton height={60} />
                                )}
                                {/*releve de compteur*/}
                                <Typography variant="body1">
                                    Relevé du compteur de votre nouvelle habitation : *
                                </Typography>
                                <Grid container>
                                    <Grid item xs={11}>
                                        <MeterReading columNumber={matches ? eight : twelve} />
                                    </Grid>
                                    {/*image pour le compteur*/}
                                    <Grid item xs={1}>
                                        <Tooltip
                                            title={
                                                <img
                                                    className="move-house-tooltip-img"
                                                    src={imgMeterReading}
                                                    alt="Relevè de compteur"
                                                />
                                            }
                                            className="move-house-tooltip"
                                            sx={{ color: theme.palette.blue.main, marginTop: '15px' }}
                                        >
                                            <InfoIcon />
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={0} sm={9} />
                    <Grid item xs={12} sm={3}>
                        <Typography variant={'button'} className={'buttons-form'}>
                            {/*bouton annulé*/}
                            <Button variant="neutral" component={Link} to={'/j-emmenage/etape-une'}>
                                Annuler
                            </Button>
                            {/*bouton valider*/}
                            <Button type="submit" variant="contained" disabled={!props.validForm}>
                                Valider
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
}
